import { easepick, LockPlugin, RangePlugin } from "@easepick/bundle";
import Rent from "../partials/template-rent";

// Global counters to keep track across multiple shadow roots

const Calendar = {
  el: null,
  picker: null,
  freeDates: [],

  init() {
    Calendar.el = $("#datepicker");
    Calendar.renderCalendar(null);
  },
  // Step 1. Get the calendar config based on the screen width.
  getCalendarConfig(screenWidth, commonConfig) {
    let calendarConfig;

    if (screenWidth < 768) {
      calendarConfig = {
        ...commonConfig,
        calendars: 1,
        grid: 1,
      };
    } else if (screenWidth < 1280) {
      calendarConfig = {
        ...commonConfig,
        calendars: 2,
        grid: 2,
      };
    } else {
      calendarConfig = {
        ...commonConfig,
        calendars: 3,
        grid: 3,
      };
    }

    return calendarConfig;
  },

  // Step 2. Initialize the calendar with the given configuration.
  initializeCalendar(commonConfig, lockedDates) {
    const screenWidth = window.innerWidth;
    const calendarConfig = Calendar.getCalendarConfig(
      screenWidth,
      commonConfig
    );

    if (lockedDates) {
      calendarConfig.LockPlugin = {
        minDate: new Date(),
        inseparable: false,
        filter: function (date) {
          const dateString = date.format("YYYY-MM-DD");
          return lockedDates.includes(dateString);
        },
      };
    }

    if (Calendar.picker) {
      Calendar.picker.destroy();
    }

    const picker = new easepick.create(calendarConfig);

    picker.on("select", function (e) {
      // Update the date range in global variables
      Rent.startDate = picker.getStartDate();
      Rent.endDate = picker.getEndDate();

      let startDate = picker.getStartDate();
      let endDate = picker.getEndDate();

      Rent.dateRangeHandler();

      // Function to check and adjust dates
      function adjustDate(date, addDays) {
        let tempDate = new Date(date);
        while (true) {
          tempDate.setDate(tempDate.getDate() + addDays);
          let dateString = tempDate.toISOString().split("T")[0];

          const easepickWrapper = $(".easepick-wrapper");
          const shadowRoot = $(easepickWrapper)[0].shadowRoot;
          const dayElement = $(shadowRoot).find(
            `.day[data-time='${tempDate.getTime()}']`
          );

          if(dayElement.hasClass("holiday") || dayElement.hasClass("locked") || dayElement.hasClass("weekend")) {
            //do next
          } else {
            return tempDate;
          }
        }
      }

      // Check if start or end dates are on holiday or locked
      const easepickWrapper = $(".easepick-wrapper");
      const shadowRoot = $(easepickWrapper)[0].shadowRoot;

      const startDayElement = $(shadowRoot).find(
        `.day[data-time='${startDate.getTime()}']`
      );
      const endDayElement = $(shadowRoot).find(
        `.day[data-time='${endDate.getTime()}']`
      );

      if (
        startDayElement.hasClass("holiday") ||
        startDayElement.hasClass("locked") ||
        startDayElement.hasClass("weekend")
      ) {
        startDate = adjustDate(startDate, 1); // Move forward if start date is on a restricted day
      }
      if (
        endDayElement.hasClass("holiday") ||
        endDayElement.hasClass("locked") ||
        endDayElement.hasClass("weekend")
      ) {
        endDate = adjustDate(endDate, 1); // Move forward if end date is on a restricted day
      }

      // Update the date selection if adjustments were made
      if (
        startDate !== picker.getStartDate() ||
        endDate !== picker.getEndDate()
      ) {
        picker.setDateRange(startDate, endDate);
      }

      // Update the date range in global variables
      Rent.startDate = startDate;
      Rent.endDate = endDate;
      Rent.dateRangeHandler();
    });
    picker.on("view", function (e) {
      const { view } = e.detail;

      // Limit script execution
      if ("Main" != view) {
        return;
      }

      const easepickWrapper = $(".easepick-wrapper");
      const shadowRoot = $(easepickWrapper)[0].shadowRoot;

      // Add disabled tooltip to the locked dates
      const lockedElements = shadowRoot.querySelectorAll(".locked");
      if (lockedElements) {
        Calendar.calendarAddTooltip(
          lockedElements,
          "Šajā datumā, konteineru nav iespējams pasūtīt"
        );
      }

      // Color green weekend days
      $(shadowRoot)
        .find(".weekend.in-range")
        .each(function () {
          $(this).addClass("freeRent");
        });

      // Add 'freeRent' class to the first 3 free days
      let freeDays = 4;

      let firstEl = Calendar.convertToTimestamp(picker.getStartDate());
      let lastEl = Calendar.convertToTimestamp(picker.getEndDate());

      // console.log(lastEl);

      let selectedElements = $(shadowRoot)
        .find(`.day[data-time='${firstEl}']`)
        .addBack()
        .add(`.day[data-time='${lastEl}']`)
        .add(
          $(shadowRoot)
            .find(`.day[data-time='${firstEl}']`)
            .nextUntil(`.day[data-time='${lastEl}']`)
        );

      if (selectedElements.length) {
        let count = 0; // To track how many freeRent days have been assigned

        for (let i = 0; i < selectedElements.length && count < freeDays; i++) {
          let element = $(selectedElements[i]);

          if (element.hasClass("weekend")) {
            continue;
          }
          element.addClass("freeRent");
          count++;
        }

        if (count < freeDays) {
          $(shadowRoot).find(".end").addClass("freeRent");
        }
      }

      // Convert selectedElements to an array and add 'rent' class to remaining elements
      Array.from(selectedElements).forEach((element) => {
        if (!$(element).hasClass("freeRent")) {
          $(element).addClass("rent");
        }
      });

      const rentElements = shadowRoot.querySelectorAll(".rent:not(.locked)");
      if (rentElements.length && Rent.selectedContainer !== null) {
        Calendar.calendarAddTooltip(
          rentElements,
          translations.calendar_tooltip +
            " " +
            Rent.selectedContainer.rent_price +
            " €"
        );

        rentElements[0].querySelector(".tooltip").classList.add("active");
      }

      // Add 'holiday' or 'custom-holiday' class to specific days
      let timezoneOffset = -new Date().getTimezoneOffset() / 60;
      let timezoneDiff = 1000 * 60 * 60 * timezoneOffset;

      $(shadowRoot)
        .find(".day")
        .each(function () {
          const thisDate = new Date(
            parseInt($(this).data("time")) + timezoneDiff
          ); // Get date from data attribute
          const dateString = thisDate.toISOString().split("T")[0];

          if (Rent.holidays.includes(dateString)) {
            $(this).addClass("holiday"); // or "custom-holiday"
          }
        });
    });

    // Set dateRange on repeat
    const setStartDate = Calendar.el.data("start");
    const setEndDate = Calendar.el.data("end");

    if (setStartDate && setEndDate) {
      picker.setDateRange(new Date(setStartDate), new Date(setEndDate));

      Rent.startDate = new Date(setStartDate);
      Rent.endDate = new Date(setEndDate);

      Rent.dateRangeHandler();
    }

    Calendar.picker = picker;
  },

  // Step 3. Render the calendar with the locked dates.
  renderCalendar(lockedDates) {
    const commonConfig = {
      element: Calendar.el[0],
      firstDay: 1,
      format: "YYYY-MM-DD",
      css: [
        "https://cdn.jsdelivr.net/npm/@easepick/bundle@1.1.6/dist/index.css",
        calendar_style,
      ],
      plugins: [RangePlugin, LockPlugin],
      inline: true,
      locale: {
        nextMonth:
          '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M5.27938 0.755445C5.36286 0.755445 5.44112 0.786749 5.49852 0.844141L9.44808 4.77805C9.50547 4.83545 9.54199 4.91371 9.54199 5.0024C9.54199 5.0911 9.51069 5.16414 9.44808 5.22153L5.49851 9.15544C5.44112 9.21284 5.36286 9.24414 5.27938 9.24414C5.19591 9.24414 5.11764 9.21284 5.05504 9.15023C4.93504 9.03023 4.93504 8.83197 5.05504 8.70675L8.47243 5.31023L0.771559 5.31023C0.599386 5.31023 0.458516 5.16936 0.458516 4.99718C0.458516 4.82501 0.599386 4.68414 0.771559 4.68414L8.47243 4.68414L5.06025 1.28762C5.00286 1.23023 4.96634 1.15197 4.96634 1.06849C4.96634 0.985011 4.99765 0.90675 5.05504 0.849358C5.11243 0.791967 5.19069 0.755445 5.27417 0.755445L5.27938 0.755445Z" fill="#3C484F"/></svg>',
        previousMonth:
          '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="9" viewBox="0 0 10 9" fill="none"><path id="Vector" d="M4.72062 8.74455C4.63714 8.74455 4.55888 8.71325 4.50149 8.65586L0.551921 4.72195C0.49453 4.66455 0.458008 4.58629 0.458008 4.4976C0.458008 4.4089 0.489312 4.33586 0.551921 4.27847L4.50149 0.344555C4.55888 0.287164 4.63714 0.255859 4.72062 0.255859C4.80409 0.255859 4.88236 0.287164 4.94496 0.349772C5.06496 0.469772 5.06496 0.668033 4.94496 0.793251L1.52757 4.18977H9.22844C9.40061 4.18977 9.54148 4.33064 9.54148 4.50282C9.54148 4.67499 9.40061 4.81586 9.22844 4.81586H1.52757L4.93975 8.21238C4.99714 8.26977 5.03366 8.34803 5.03366 8.43151C5.03366 8.51499 5.00236 8.59325 4.94496 8.65064C4.88757 8.70803 4.80931 8.74455 4.72583 8.74455H4.72062Z" fill="#3C484F"/></svg>',
      },
      RangePlugin: {
        tooltip: false,
        repick: false,
      },
      LockPlugin: {
        minDate: new Date(),
      },
    };

    if (lockedDates) {
      commonConfig.LockPlugin = {
        minDate: new Date(),
        inseparable: false,
        filter: function (date) {
          const dateString = date.format("YYYY-MM-DD");
          return lockedDates.includes(dateString);
        },
      };
    }

    // Track the current screen width category
    let currentWidthCategory = getScreenWidthCategory();

    function getScreenWidthCategory() {
      const screenWidth = window.innerWidth;
      if (screenWidth < 768) return "small";
      if (screenWidth < 1280) return "medium";
      return "large";
    }

    function checkAndReinitializeCalendar() {
      const newWidthCategory = getScreenWidthCategory();
      if (newWidthCategory !== currentWidthCategory) {
        currentWidthCategory = newWidthCategory;
        Calendar.initializeCalendar(commonConfig, lockedDates);
      }
    }

    function debounce(func, wait) {
      let timeout;
      return function (...args) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), wait);
      };
    }

    Calendar.initializeCalendar(commonConfig, lockedDates);

    // Add debounced resize event listener to reinitialize calendar on resize
    const debouncedResize = debounce(checkAndReinitializeCalendar, 50);

    $(window).resize(debouncedResize);
  },

  convertToTimestamp(dateString) {
    const date = new Date(dateString);
    return date.getTime();
  },

  calendarAddTooltip(dayItems, message) {
    if (!dayItems) {
      return;
    }

    dayItems.forEach((element) => {
      const tooltip = document.createElement("div");
      tooltip.classList.add("tooltip");
      tooltip.textContent = message;
      element.appendChild(tooltip);

      const hoverArea = document.createElement("div");
      hoverArea.classList.add("hover-area");
      element.appendChild(hoverArea);

      // Add class 'active' to tooltip when hover-area is hovered over
      hoverArea.addEventListener("mouseenter", function () {
        tooltip.classList.add("active");
      });

      // Remove class 'active' from tooltip when mouse leaves hover-area
      hoverArea.addEventListener("mouseleave", function () {
        tooltip.classList.remove("active");
      });
    });
  },
};

export default Calendar;
